import api from "./axios";


// Today attendance
export const getTodayAttendance = async () => {

    const response = await api.get(
        "/attendance/today"
    );

    return response.data;

};




// Check In
export const checkInAttendance = async (data) => {

    const response = await api.post(
        "/attendance/check-in",
        data
    );

    return response.data;

};




// Check Out
export const checkOutAttendance = async (data) => {

    const response = await api.post(
        "/attendance/check-out",
        data
    );

    return response.data;

};


/*
|--------------------------------------------------------------------------
| GET ATTENDANCES
|--------------------------------------------------------------------------
|
| Supports:
| - page
| - limit
| - employeeName
| - fromDate
| - toDate
| - status
|
| Existing usage is still supported:
|
| getAttendances(page, limit)
|
|--------------------------------------------------------------------------
*/

// ============================================================
// GET ATTENDANCES
// ============================================================

export const getAttendances = async (
    page = 1,
    limit = 10,
    filters = {}
) => {

    const params = {
        page,
        limit,
    };


    // ========================================================
    // EMPLOYEE
    // ========================================================

    if (
        filters?.employeeId !== "" &&
        filters?.employeeId !== null &&
        filters?.employeeId !== undefined
    ) {

        params.employeeId =
            filters.employeeId;

    }


    // ========================================================
    // FROM DATE
    // ========================================================

    if (
        filters?.fromDate
    ) {

        params.fromDate =
            filters.fromDate;

    }


    // ========================================================
    // TO DATE
    // ========================================================

    if (
        filters?.toDate
    ) {

        params.toDate =
            filters.toDate;

    }


    // ========================================================
    // STATUS
    // ========================================================

    if (
        filters?.status
    ) {

        params.status =
            filters.status;

    }


    console.log(
        "Attendance API Params:",
        params
    );


    return api.get(
        "/attendance",
        {
            params,
        }
    );

};



// Attendance GPS Logs

export const getAttendanceGpsLogs = async (id) => {


    const response = await api.get(
        `/attendance/${id}/gps-logs`
    );


    return response.data;


};